import { Beneficiary } from './Beneficiary';

export enum MaritalStatus {
  Single = 'Single',
  Married = 'Married',
  Widowed = 'Widowed',
  Divorced = 'Divorced',
}

export interface Beneficiaries {
  maritalStatus: MaritalStatus;
  applyToChildAccounts: boolean;
  primaryBeneficiaries: Beneficiary[];
  contingentBeneficiaries: Beneficiary[];
}
export default Beneficiaries;
